export const stringify = (obj) => {
  const params = [];

  for (const key in obj) {
    if (!Object.prototype.hasOwnProperty.call(obj, key)) continue;

    const value = obj[key];

    if (value === undefined) {
      continue;
    }

    if (Array.isArray(value)) {
      for (const item of value) {
        if (item !== undefined) {
          params.push(`${encodeURIComponent(key)}=${encodeURIComponent(item)}`);
        }
      }
    } else {
      params.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
    }
  }

  return params.join('&');
}
